import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { Injectable } from '@angular/core';
import { GerarDacteRequest } from '../../requests/report/gerar-dacte.request';

@Injectable({
  providedIn: 'root',
})
export class DacteService extends CommonService {
  constructor(
    private httpClient: HttpClient
  ) {
    super();
  }

  // A URL base para o controller PanielContador.
  // Certifique-se de que a variável 'urlApiRepoDFe' existe no seu arquivo environment.ts
  private readonly apiUrl = `${environment.urlApiReport}Dacte`;

  /**
  * Faz o Download da DACTe.
  * @param nomeXml O nome da nota fiscal.
  */
  public gerarDACTe(request: GerarDacteRequest): Observable<Blob> {
    const url = `${this.apiUrl}/gerarPdf`;
    // É crucial definir o responseType como 'blob' para receber o arquivo
    const options = {
      ...this.addHeaderToken(),
      responseType: 'blob' as 'json', // O cast é necessário por causa da tipagem padrão
    };

    return this.httpClient
      .post<Blob>(url, request, options)
      .pipe(catchError(this.handleError));
  }
}
